import { configureStore } from "@reduxjs/toolkit";
import productListSlice from '../slice/propertyListSlice'
import propertyDetailsSlice from '../slice/propertyDetailsSlice'
import homeSlice from "../slice/homeSlice"

const store = configureStore({
  reducer: {
    propertyList: productListSlice,
    productDetails: propertyDetailsSlice,
    home: homeSlice
  },
});

export default store;
